/**
 * Frime — lightweight interaction tracking.
 *
 * Pushes to window.dataLayer (GTM) and window.gtag (GA4) when present.
 * If neither exists the calls are silent no-ops, so this is safe to ship
 * before analytics is configured.
 */
(function () {
  function track(name, params) {
    var payload = params || {};
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, payload));
    } catch (e) {
      /* no-op */
    }
    try {
      if (typeof window.gtag === 'function') window.gtag('event', name, payload);
    } catch (e) {
      /* no-op */
    }
  }

  window.frimeTrack = track;

  function productContext() {
    var el = document.querySelector('[data-frime-product]');
    if (!el) return {};
    return {
      item_id: el.getAttribute('data-frime-product-id') || undefined,
      item_name: el.getAttribute('data-frime-product') || undefined
    };
  }

  document.addEventListener('click', function (e) {
    // certificate / quality hub links
    var q = e.target.closest('.frime-quality-link, .frime-quality__link, .frime-compliance__certlink');
    if (q) {
      track('certificate_click', Object.assign({ link_url: q.getAttribute('href') || '' }, productContext()));
      return;
    }

    // goal chips on the collection page
    var chip = e.target.closest('[data-chip]');
    if (chip) {
      track('collection_filter', { filter_value: (chip.textContent || '').trim() });
      return;
    }

    // quiz interactions
    if (e.target.closest('[data-quiz-option]')) {
      var root = e.target.closest('[data-quiz]');
      var answered = root ? root.getAttribute('data-answered') || '0' : '0';
      var n = parseInt(answered, 10) + 1;
      if (root) root.setAttribute('data-answered', String(n));
      if (n === 1) track('quiz_start', {});
      track('quiz_answer', { step: n });
      var total = root ? parseInt(root.getAttribute('data-total') || '0', 10) : 0;
      if (total && n >= total) {
        track('quiz_complete', { steps: total });
        window.setTimeout(function () {
          var rec = document.querySelector('.frime-quiz__rec-title');
          track('quiz_recommendation', { item_name: rec ? rec.textContent.trim() : '' });
        }, 150);
      }
      return;
    }

    if (e.target.closest('[data-quiz-restart]')) {
      var r2 = e.target.closest('[data-quiz]');
      if (r2) r2.setAttribute('data-answered', '0');
      track('quiz_restart', {});
    }
  });

  // accordion opens: ingredients / usage / quality / faq
  // Matched on ASCII-safe fragments: Turkish 'İ'.toLowerCase() yields a
  // combining dot, so leading-character matches are unreliable.
  var accordionMap = [
    ['ndekiler', 'ingredients_expand'],
    ['kullan', 'usage_expand'],
    ['kalite', 'quality_expand'],
    ['sorulan', 'faq_expand']
  ];

  document.addEventListener(
    'toggle',
    function (e) {
      var d = e.target;
      if (!d || d.tagName !== 'DETAILS' || !d.open) return;
      var summary = d.querySelector('.accordion__title');
      if (!summary) return;
      var label = (summary.textContent || '').trim().toLowerCase();
      var name = null;
      accordionMap.forEach(function (pair) {
        if (!name && label.indexOf(pair[0]) !== -1) name = pair[1];
      });
      track(name || 'accordion_expand', Object.assign({ section_title: summary.textContent.trim() }, productContext()));
    },
    true
  );

  // sticky mobile add-to-cart
  document.addEventListener('click', function (e) {
    if (e.target.closest('#FrimeStickyAdd')) {
      track('sticky_atc_click', productContext());
    }
  });
})();
